import React, { useEffect, useState } from 'react'
import { FormControlLabel, Switch } from '@material-ui/core';
import axios from 'axios';
import { toast } from 'react-toastify';
import MachineSwitch from './MachineSwitch';
import TempSwitch from './TempSwitch';

const PCOnOffSwitch = () => {
    const [isOn, setIsOn] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const saved = localStorage.getItem("pc-switch-isOn");
        if(saved !== null) {
            setIsOn(JSON.parse(saved));
        }
    }, []);

    const handleToggle = async (e) => {
        const newState = !e.target.checked;
        setLoading(true);
        setIsOn(newState);
        localStorage.setItem("pc-switch-isOn", JSON.stringify(newState));

        const payload = {
            topic: "esp6201",
            message: {
                state: newState ? "ON".toUpperCase() : "OFF".toUpperCase(),
            },
        };
        
        try {
            await axios.post(
                process.env.REACT_APP_IOT_RELAY_ENDPOINT,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );
            
            toast.success(`LCD turned ${newState ? 'OFF' : 'ON'} successfully.`);
        } catch(err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <h1>Switch</h1>
            <FormControlLabel
                control={
                    <Switch
                        checked={!isOn}
                        onChange={handleToggle}
                        color="primary"
                        disabled={loading}
                    />
                }
                label={isOn ? "LCD Off" : "LCD On"}
            />
            <MachineSwitch />
            <TempSwitch />
        </>
    );
}

export default PCOnOffSwitch;